module.exports = __webpack_public_path__ + "assets/retina_LineBetweenPointsDetailed.80d6cc6575b7afe1b499abb3ef1eeac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LineBetweenPointsDetailed.png
// module id = 690
// module chunks = 0